module.exports = false;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/is-pure.js